<template>
  <div>
    <div class="flex flex-wrap pb-16">
      <div
        :class="[
          'pr-4 pl-4 pt-1 pb-1 rounded ml-4 mr-4 pt-2 mb-2 text-center flex justify-center items-center w-full',
        ]"
        :style="processTekst"
      >
        <svg
          class="mr-1"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#4A5568"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {{ lang["please_select_table"][language] }}
      </div>

      <div
        v-for="table in tables"
        :key="table.id"
        @click="selectTable(table.Id)"
        class="w-full flex justify-center my-2"
      >
        <div
          :class="[
            'text-center w-3/4 rounded-large transition duration-500 border-2 h-12 items-center flex justify-center',
            table.Id === tableId
              ? /* theme.body.selectedBackgroundColor*/ 'bg-new-primary border-new-primary'
              : '',
          ]"
          :style="
            table.Id === tableId
              ? makeStyles(btnMainBackground , btnMainText , btnOutlineBorder , hasKiosk && mainButtonRadius)
              : makeStyles(btnSecondText , btnSecondBackground , hasKiosk && secondButtonRadius)
          "
        >
          {{ table.table_description }}
        </div>
      </div>
      <div v-if="isTablesLoading&&!tables.length"
      class="w-full flex justify-center items-center">
        <ClipLoader/>
      </div>
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import Axios from "axios";
export default {
components: { ClipLoader },
  data() {
    return {
      lang: lang,
    };
  },
  computed: {
    ...mapGetters(["language", "theme","hasKiosk"]),
    ...mapGetters("Cart", ["tables", "tableId","isTablesLoading","customer"]),
    ...mapGetters("Theme", [
      "mainButtonRadius",
      "btnMainBackground",
      "btnSecondBackground",
      "secondButtonRadius",
      "btnMainText",
      "btnSecondText",
      "btnOutlineBorder",
      "processTekst",
    ]),
    // if we already know the tableId we fill it in, we also keep listening to the value's. If it changes, store them in de cookies and vuexx
    tableId: {
      get() {
        return this.$store.getters["Cart/tableId"];
      },
      set(value) {
        this.$store.commit("Cart/updateTableId", value);
        let table = this.tables.find(el => el.Id == value);
        this.$store.commit("Cart/updateStickerId", table.stickerId);
        
        // localStorage.setItem("tableId", value);
      },
    },
  },
  methods: {
    selectTable(tableId) {
      this.tableId = tableId;
      this.sendLogs();
    },
    sendLogs() {
      let arr = [];
        arr.push("Table Id Selected via Table selection component.");
        arr.push(this.$store.getters.menu);
        arr.push(this.customer);
        arr.push(this.tableId );
        arr.push("browser", this.$browserDetect.meta.name);
        arr.push("ios", this.$browserDetect.isIOS);
        arr.push("version", this.$browserDetect.meta.version);
        let data = {
          MenuHash: this.$store.getters.menuHash,
          Dump: JSON.stringify(arr),
        };
        Axios
          .post(
            `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
            data
          )
          .then(() => {});
    }
  },
  mounted() {
    if (!this.isTablesLoading && !this.tables.length) {
      // get the tables from the back-end
      this.$store.dispatch("Cart/GET_TABLES").catch((error) => {
          if (error.response.status == 404) {
            this.$router.go(-3);
            }
        });
    }
    },
    updated() {
        // check if you can continue to the next step or not
        if (this.tableId > 0) {
            this.$store.commit("updateIsCickable", "");
        }
        else {
            this.$store.commit("updateIsCickable", "opacity-40 cursor-not-allowed");
        }
    },
};
</script>

<style scoped>
.mobileScroll {
  height: 50vh;
  overflow: scroll;
  margin-bottom: 20px;
}
</style>
